import { __assign } from "tslib";
var LOCAL_STORAGE_KEY = 'marvel3';
var canUseDOM = !!(typeof window !== 'undefined' &&
    window.document &&
    window.document.createElement);
export function reset() {
    if (canUseDOM) {
        window.localStorage.removeItem(LOCAL_STORAGE_KEY);
    }
}
function readCache() {
    if (canUseDOM) {
        try {
            var ls = window.localStorage;
            var rawCache = ls.getItem(LOCAL_STORAGE_KEY) || '{}';
            return JSON.parse(rawCache);
        }
        catch (e) {
            // This means the JSON is corrupt, let's clear it and start again
            reset();
            return {};
        }
    }
}
export function get(key) {
    if (canUseDOM) {
        return readCache()[key];
    }
}
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function set(key, value) {
    var _a;
    if (canUseDOM) {
        setCache(__assign(__assign({}, readCache()), (_a = {}, _a[key] = value, _a)));
    }
}
export function remove(key) {
    if (canUseDOM) {
        var currentCache = readCache();
        // delete specific property off the marvel3 object in cache
        delete currentCache[key];
        setCache(currentCache);
    }
}
function setCache(value) {
    window.localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(value));
}
export function getMatchingValueFromCache(cacheKey, options) {
    if (!cacheKey)
        return null;
    var keyFromCache = get(cacheKey);
    return options.find(function (_a) {
        var key = _a.key;
        return key === keyFromCache;
    }) ? keyFromCache : null;
}
